import { Injectable } from '@angular/core';
import { GqlParser, MutationResult, QueryResult } from '@unipin/angular-gql';
import { Observable } from 'rxjs';
import { BookmarksQueryCriteria, CmsBookmarks, CmsPostConnection, CmsPostFilterPublic, CmsPostViews, CreateBookmarkRq, MutationCmsMsDeleteBookmarkArgs } from 'graphql/generated';
import { CountryService } from './country.service';

@Injectable({ 
  providedIn: 'root' 
})
export class PostService {

  protected readonly baseAttr: string = `
    guid
    urlKey
    postTitle
    createdAt
    authorName
    publishedAt
    videoSource
    countryCode
    contentOption
    author {
      url
      guid
      userName
    }
    categories {
      guid
      urlKey
      termName
    }
    postExt {
      guid
      extType
      file {
        publicUrl
      }
    }
    tags {
      guid
      urlKey
      termName
    }
    viewCount
  `;

  constructor(
    protected readonly gql: GqlParser,
    protected readonly countryService: CountryService
  ) { }

  public query(filter: CmsPostFilterPublic, extraAttr: string = '', isHome: boolean = false): Observable<QueryResult<{ cmsMsPostsPublic: CmsPostConnection }>>{
    filter.countryCode = this.countryService.activeCountry().code;
    
    return this.gql.query({
      operationName: 'QueryPost',
      variables: { 
        isHome,
        filter,
      },
      query: `
        query QueryPost($filter: CmsPostFilterPublic!, $isHome: Boolean!) {
          cmsMsPostsPublic(filter: $filter, isHome: $isHome) {
            pageInfo {
              endCursor
              hasNextPage
            }
            edges {
              node {
                ${ this.baseAttr }
                ${ extraAttr }
              }
            }
          }
        }
      `
    });
  }

  public queryBookmarked(input: BookmarksQueryCriteria): Observable<QueryResult<{ cmsMsBookmarks: CmsBookmarks[] }>>{
    input.countryCode = this.countryService.activeCountry().code;
    
    return this.gql.query({
      operationName: 'CmsMsBookmarks',
      variables: { 
        input 
      },
      query: `
        query CmsMsBookmarks($input: BookmarksQueryCriteria) {
          cmsMsBookmarks(input: $input) {
            guid
            posts {
              ${ this.baseAttr }
            }
          }
        }
      `
    });
  }

  public markBookmark(input: CreateBookmarkRq): Observable<MutationResult<{ cmsMsCreateBookmark: CmsBookmarks }>>{
    return this.gql.mutate({
      operationName: 'MarkBookmark',
      variables: { 
        input 
      },
      mutation:`
        mutation MarkBookmark($input: CreateBookmarkRq) {
          cmsMsCreateBookmark(input: $input) {
            guid
            postGuid
            status
            userGuid
          }
        }
      `
    });
  }

  public removeBookmark(variables: MutationCmsMsDeleteBookmarkArgs): Observable<MutationResult<{ cmsMsDeleteBookmark: CmsBookmarks }>>{
    return this.gql.mutate({
      variables,
      operationName: 'RemoveBookmark',
      mutation:`
        mutation RemoveBookmark($guid: String) {
          cmsMsDeleteBookmark(guid: $guid) { guid }
        }
      `
    });
  }

  public increaseView(guid: string): Observable<MutationResult<{ cmsMsCreatePostViews: CmsPostViews }>>{
    return this.gql.mutate({
      operationName: 'ViewPost',
      variables: { 
        guid 
      },
      mutation: `
        mutation ViewPost($guid: String!) {
          cmsMsCreatePostViews(postGuid: $guid) { guid }
        }
      `
    });
  }
}
